import { useEffect, useState } from 'react';
import { listClassifiedsByIsbn } from '../utils/api/classifiedApi';
import { captureException } from '../utils/sentry';
var firstDefined = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return values
        .find(function (value) { return value !== undefined && value !== null; });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var asClassifiedStandardFormat = function (classified) {
    var salePoint = classified.salePoint || classified.sale_point;
    var school = classified.school;
    var zipCode = (salePoint === null || salePoint === void 0 ? void 0 : salePoint.zipCode) || (salePoint === null || salePoint === void 0 ? void 0 : salePoint.zip_code);
    var formatted = {
        id: classified.id,
        amount: classified.amount ? parseInt(classified.amount, 10) : undefined,
        bookId: parseInt(firstDefined(classified.bookId, classified.book_id), 10),
        userId: parseInt(firstDefined(classified.userId, classified.user_id), 10),
        condition: classified.condition,
        price: parseInt(classified.price, 10),
        status: classified.status,
        pickupAt: classified.pickupAt || classified.pickup_at,
        expirationDate: classified.expiration_date,
        lastChanged: classified.lastChanged || classified.last_changed,
        timeCreated: classified.timeCreated || classified.time_created,
        hasContacted: firstDefined(classified.hasContacted, classified.has_contacted, false),
        hasVipps: firstDefined(classified.hasVipps, classified.has_vipps, false),
    };
    if (salePoint) {
        formatted.salePoint = {
            id: salePoint.id,
            salePoint: salePoint.salePoint || salePoint.sale_point || salePoint.name,
            zipCode: {
                id: firstDefined(zipCode === null || zipCode === void 0 ? void 0 : zipCode.id, zipCode === null || zipCode === void 0 ? void 0 : zipCode.areaCode),
                city: firstDefined(zipCode === null || zipCode === void 0 ? void 0 : zipCode.city, zipCode === null || zipCode === void 0 ? void 0 : zipCode.areaName),
            },
        };
    }
    if (school) {
        formatted.school = {
            id: school.id,
            name: school.name,
            shortName: school.shortname,
            address: school.address,
            department: school.department,
            educationGrade: school.educationGrade || school.education_grade,
        };
    }
    return formatted;
};
var defaultLocation = 'All';
var useActiveClassifiedList = function (options) {
    var isbn = options.isbn, _a = options.selectedLocation, selectedLocation = _a === void 0 ? defaultLocation : _a;
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), hasLoaded = _c[0], setHasLoaded = _c[1];
    var _d = useState({}), locations = _d[0], setLocations = _d[1];
    var _e = useState([]), classifieds = _e[0], setClassifieds = _e[1];
    // eslint-disable-next-line no-shadow
    var listClassifieds = function (isbn, location) {
        setIsLoading(true);
        listClassifiedsByIsbn(isbn, location)
            .then(function (data) {
            setClassifieds(data.classifieds.map(asClassifiedStandardFormat));
            setLocations(data.locations);
            setHasLoaded(true);
        })
            .catch(function (err) { return captureException(err, null, {
            isbn: isbn,
            'classified.location': location,
        }); })
            .finally(function () {
            setIsLoading(false);
        });
    };
    useEffect(function () {
        if (isLoading) {
            return;
        }
        listClassifieds(isbn, selectedLocation);
        // eslint-disable-next-line
    }, [isbn, selectedLocation]);
    return {
        hasLoaded: hasLoaded,
        locations: locations,
        classifieds: classifieds,
    };
};
export default useActiveClassifiedList;
